module.exports = __webpack_public_path__ + "img/ch20.d75baa5f.jpg";